(function ($) {
  $(function () {
    $("html.no-js").removeClass("no-js").addClass("has-js");

    damaxRegister();

    $(window).scroll(function () {
      stickyHeader();
    });

    $(window).bind("load", function () {
      stickyHeader();
    });
  });

  function damaxRegister() {
    damaxToggleMenu();
    stickyHeader();
  }

  function damaxToggleMenu() {
    $(".burger").click(function () {
      $(this).toggleClass("on");
      $(".nav-menu").slideToggle();
      $("body").toggleClass("menu_expand");
    });
  }

  function stickyHeader() {
    if ($(window).scrollTop() > 0) {
      $(".header").addClass("header-sticky");
    } else {
      $(".header").removeClass("header-sticky");
    }
  }
})(jQuery);
